import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { UserContext } from "../app/App";
import ConfigData from "../config/config.json";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const webserver = ConfigData.WEBSERVER;

export default function CustomizedSnackBar() {
  const { setUser } = React.useContext(UserContext);
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/logout",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unauthorized");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setUser((prevState) => {
          return { name: "", authenticated: false, role: "" };
        });
      })
      .catch((error) => {
        setUser({ name: "", authenticated: false, role: "" });
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <List sx={{ marginTop: "auto" }}>
        <ListItem key="logout" disablePadding>
          <ListItemButton onClick={handleClick}>
            <ListItemIcon>
              <LogoutRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Abmelden" />
          </ListItemButton>
        </ListItem>
      </List>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Erfolgreich abgemeldet!
        </Alert>
      </Snackbar>
    </>
  );
}
